// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as GeoRegionRepoConfig from "./GeoRegionRepoConfig.bs.js";

var dummyGeoRegions = {
  "geo_regions": [
    {
      "id": 11,
      "name": "Lucknow",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 4,
      "name": "Hyderabad",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 8,
      "name": "Pune",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 6,
      "name": "Ahmedabad",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 10,
      "name": "Surat",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 5,
      "name": "Chennai",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 9,
      "name": "Kolkata",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 7,
      "name": "Jaipur",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 13,
      "name": "Indore",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 1,
      "name": "Mumbai",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 15,
      "name": "Chandigarh",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 2,
      "name": "Delhi NCR",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 17,
      "name": "Ludhiana",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 18,
      "name": "Kochi",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 16,
      "name": "Vadodara",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 3,
      "name": "Bangalore",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 14,
      "name": "Nagpur",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 12,
      "name": "Coimbatore",
      "timezone": "Asia/Kolkata"
    },
    {
      "id": 19,
      "name": "Nashik",
      "timezone": "Asia/Kolkata"
    }
  ]
};

function fetchGeoRegions(_country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyGeoRegions
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(GeoRegionRepoConfig.GeoRegionResponseConverter.execute, result);
                        });
            });
}

function useGeoRegions(country) {
  var match = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var updateGeoRegions = match[1];
  var $$fetch = function (param) {
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return fetchGeoRegions(country);
                }), (function (data) {
                  return Curry._1(updateGeoRegions, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(updateGeoRegions, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }));
  };
  React.useEffect((function () {
          $$fetch(undefined);
          
        }), []);
  return match[0];
}

var GeoRegionRepo = {
  dummyGeoRegions: dummyGeoRegions,
  fetchGeoRegions: fetchGeoRegions,
  useGeoRegions: useGeoRegions
};

export {
  GeoRegionRepo ,
  
}
/* react Not a pure module */
